export default __webpack_public_path__ + "static/media/icon.a77dcd17.png";